export type Palette = string[]

export const PALETTES: Palette[] = [
  ['#D6C5F0', '#1B0044', '#F7D914'],
  ['#87E0FF', '#0D0021', '#FFFFE3'],
  ['#0F4137', '#E7F5F2', '#12776F'],
  ['#301551', '#FFFFFF', '#ED8A0A'],
  ['#5454C5', '#FFFFFF', '#230977'],
  ['#2B2726', '#FFFFFF', '#018790'],
  ['#F6F7D3', '#181615', '#EACD65'],
  ['#F3F3F3', '#181615', '#F3F66F'],
  ['#81C196', '#FFFFFF', '#1E281B'],
  ['#1E3673', '#FFFFFF', '#60B6A7'],
  ['#5397D5', '#FFFFFF', '#812917'],
  ['#FFFFFF', '#364E4D', '#97B74C'],
  ['#E3F0FB', '#2355A7', '#EBB43E'],
  ['#9B99FF', '#2002D9', '#FFFB8E'],
  ['#E7D8C7', '#0F110D', '#FFFFFF'],
  ['#AFA496', '#0F110D', '#FFFFFF'],
  ['#51216D', '#FDFFFF', '#DB2929'],
  ['#13232E', '#FDFFFF', '#8C8AF6'],
  ['#8CDDC5', '#1D2A3B', '#3FCADD'],
  ['#FFFFFF', '#13232E', '#E2CBF6'],
  ['#DBE3FC', '#0C142C', '#FFC444'],
  ['#FFFFFF', '#364E4D', '#97B74C'],
  ['#BB374F', '#FFFFFF', '#6C0800'],
  ['#F0CAFF', '#0E0067', '#58EE85'],
  ['#8EC7FF', '#000000', '#FDFFFF'],
  ['#94EB96', '#232825', '#FFFFFF'],
  ['#ACF7CD', '#35393D', '#FFFEFF'],
  ['#13232E', '#FDFFFF', '#8C8AF6'],
  ['#8CDDC5', '#1D2A3B', '#3FCADD'],
  ['#FFFFFF', '#13232E', '#D7D7D7'],
  ['#09180A', '#EFF5FB', '#84A2FF'],
  ['#152738', '#FFFFFF', '#2F84D5'],
  ['#1B1F21', '#FFFFFF', '#EB70A0'],
  ['#8C8AF6', '#0E0067', '#58EE85'],
  ['#479DF1', '#FDFDFD', '#081335'],
  ['#2002D9', '#EAECE7', '#8C8AF6'],
  ['#282A2A', '#FFFEF9', '#97B74C'],
  ['#C39C6C', '#FDFFFF', '#252B14'],
  ['#F98837', '#FFFFFF', '#C54200'],
  ['#FFE3D3', '#953935', '#FFB2B3'],
  ['#8B0000', '#EFF5FB', '#000000'],
  ['#372712', '#FFFFFF', '#AB8F6D'],
  ['#C9F2A0', '#000000', '#F874A7'],
  ['#4F4851', '#FFFFFF', '#000000'],
  ['#F14749', '#FDFDFD', '#092371'],
]
